<template>
  <div style="display: flex; justify-content: center; ">
    <el-card style="width: 500px; border-radius: 10px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
      <template #header>
        <div style="text-align: center; font-size: 20px; padding: 10px;">Card name</div>
      </template>
      <div >
        <table style="width: 90%;">
          <tr>
            <td>ID：</td>
            <td>{{ s.id }}</td>
          </tr>
          <tr>
            <td>用户名：</td>
            <td>{{ s.username }}</td>
          </tr>
          <tr>
            <td>昵称：</td>
            <td>{{ s.nickName }}</td>
          </tr>
          <tr>
            <td>头像：</td>
            <td>{{ s.avatar }}
              <el-avatar
                  src="https://localhost:8090/hsq/file/1710508278683"
              /></td>
          </tr>
          <tr>
            <td>性别：</td>
            <td>{{ s.sex }}</td>
          </tr>
          <tr>
            <td>年龄：</td>
            <td>{{ s.age }}</td>
          </tr>
          <tr>
            <td>电话：</td>
            <td>{{ s.phoneNumber }}</td>
          </tr>
        </table>
      </div>
      <template #footer>
        <div style="text-align: center; padding: 10px;">Footer content</div>
      </template>
    </el-card>
  </div>
</template>

<style scoped>

</style>
<script>
import request from "@/utils/request";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Info",
  data(){
    return{
      s:"",
      user:localStorage.getItem('user')?JSON.parse(localStorage.getItem('user')):{},

    }
  },
  mounted() {
    this.findbyid()
  },
  methods:{
    findbyid(){
      request.post("/userinfo/get", this.user).then(res=>{
        this.s=res.data[0]
      })
    }
  },
}
</script>